// Pad eventManager
// event Emitter installed thanks to bower
import {EventEmitter2} from 'eventemitter2'

const eventManager = new EventEmitter2();

export default eventManager;